
// Video cover buttons
// This is a pseudo play button as a sibling to the <video> element
$('.video-cover-btn').off().click(function(e) {
  var thisVideoButton = $(this);
  var video = $(this).siblings('video');
  // Display as default controls while playing
  thisVideoButton.addClass('min');
  video[0].play();
  video.attr('controls', '');
  // Reset when video ends
  video.on('ended',function(){
    video[0].load(); // Show poster image
    video.removeAttr('controls'); // Hide controls
    thisVideoButton.removeClass('min'); // Show play button
  });
  video.on('pause',function(){
    video.removeAttr('controls'); // Hide controls
    thisVideoButton.removeClass('min'); // Show play button
  });
});
